import React, { useEffect, useState } from 'react';
import { getLocaleData } from '@mb/lib/i18n';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import useSWR from 'swr';
import * as Styled from './CollectionsContainer.styles';
import {
  postFetcher,
  getSearchConfig,
  getLanguageKey,
  getUserData,
} from '../../../../../../../CuratedCollections/view/frontend/web/js/utils';
import { CollectionsSkeleton } from '../../components/CollectionsSkeleton/CollectionsSkeleton';
import { CollectionsView } from '../../components/CollectionsView/CollectionsView';
import { organizeCollections, organizeFacets } from '../../helpers';
import store from '../../redux/store';

const searchConfig = getSearchConfig();
const languageKey = getLanguageKey();
const customer = getUserData();

export const CollectionsContainer = () => {
  const { data, error, isLoading } = useSWR(
    `${searchConfig.siteUrl}/collection/list`,
    (url: string) =>
      postFetcher(url, {
        customer: {
          id: customer ? customer.customer_id : '',
          email: customer ? customer.email : '',
          projectId: customer ? parseInt(customer.current_project, 10) : 0,
          country: customer ? customer.country : '',
          province: customer ? customer.state : '',
        },
        siteId: searchConfig.siteId,
        lang: languageKey,
        type: ['curated_collection'],
        subtype: ['default'],
        resultsPerPage: 9000,
        filters: [],
      }),
    { revalidateOnFocus: false, suspense: false },
  );

  const [langData, setLangData] = useState({
    currentLocale: 'en',
    messages: undefined,
  });

  useEffect(() => {
    handleLangData();
  }, []);

  const handleLangData = async () => {
    const data = await getLocaleData();
    // @ts-expect-error // TODO: fix types
    setLangData(data);
  };

  if (error) {
    return <Styled.EmptyState>Error: {error.message}</Styled.EmptyState>;
  }

  if (isLoading) {
    return <CollectionsSkeleton />;
  }

  if (!data) {
    return <Styled.EmptyState>No collections found</Styled.EmptyState>;
  }

  return (
    <IntlProvider
      messages={langData?.messages}
      locale={langData?.currentLocale}
      defaultLocale="en"
    >
      <Provider store={store}>
        <CollectionsView
          collections={organizeCollections(data)}
          facets={organizeFacets(data.facets)}
        />
      </Provider>
    </IntlProvider>
  );
};
